import { getdatatype } from "@project/components/fbMenuRightFn"
import { list_url } from "@project/sharedcomponents/apiURL"
import { getAxiosCancelToken, getCatchErrorMessage, isblank, setAxiosCancelToken } from "@project/sharedcomponents/utilityFunctions"
import axios from "axios"
import { getAccountSitesetting, getheaders, getMenuData, handleResponse, postErrorOnException } from "../Lib/commonfunctions"
import { LAST_PAGE_UPDATE, LOADING_STATE, PAGES_DATA_UPDATE, PAGES_LOCAL_SEARCH, PAGES_SERVICE_CLEAR, PAGES_SERVICE_FAIL, PAGES_SERVICE_START, PAGES_SERVICE_SUCCESS, SNACKBAR_STATE } from "./types"

export const Pages_data_clear = () => {
  return (dispatch) => {
    dispatch({
      type: PAGES_SERVICE_CLEAR,
    })
  }
}

export const Pages_data_update = (data) => {
  return (dispatch) => {
    dispatch({
      type: PAGES_DATA_UPDATE,
      data: data,
    })
  }
}

export const local_search_Pages = ({ search_text }) => {
  return (dispatch) => {
    dispatch({
      type: PAGES_LOCAL_SEARCH,
      search_text: search_text,
    })
  }
}

export const fetch_Pages_data = ({ companycode, rowsPerPage, page, order, orderBy, search_text, other_type }) => {
  const pagination_size = getAccountSitesetting("pagination_size")
  if (isblank(rowsPerPage)) {
    rowsPerPage = pagination_size
  }

  return (dispatch) => {
    dispatch({ type: LOADING_STATE, state: true })
    if (typeof getAxiosCancelToken() != typeof undefined) {
      getAxiosCancelToken().cancel("Operation canceled due to new request.")
    }
    // save the new request for cancellation
    setAxiosCancelToken(axios.CancelToken.source())
    dispatch({ type: PAGES_SERVICE_START })
    let data = new FormData()
    data.append("offset", page * rowsPerPage)
    data.append("type", "customPageFormList")
    data.append("other_type", other_type)
    data.append("limit", rowsPerPage)
    data.append("sort_order", order)
    data.append("sort_by", orderBy)
    data.append("search_text", search_text)
    axios.defaults.headers.common = getheaders()
    axios({
      method: "post",
      url: list_url({ type: "customPageFormList" }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },

      data: data,
      cancelToken: getAxiosCancelToken().token,
    })
      .then((response) => handleResponse(response, dispatch))
      .then((response) => {
        if (response.data.meta.code === 401) {
          PagesServiceFail({ dispatch, response: response.data.meta.message, rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          PagesServiceSuccess({ dispatch, user: response, rowsPerPage, page, order, orderBy, search_text, other_type })
          dispatch({
            type: LAST_PAGE_UPDATE,
            lasttype: "customPageFormList",
            lastaction: "list",
            lasttime: new Date().getTime(),
            lastdata: "",
          })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          postErrorOnException(error)
          PagesServiceFail({ dispatch, response: getCatchErrorMessage(error), rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
  }
}

const PagesServiceSuccess = ({ dispatch, user, rowsPerPage, page, order, orderBy, search_text, other_type }) => {
  dispatch({
    type: PAGES_SERVICE_SUCCESS,
    payload: user,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
    getdatatype: getdatatype(getMenuData),
    other_type: other_type,
  })
}

const PagesServiceFail = ({ dispatch, response, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: SNACKBAR_STATE,
    payload: true,
    message: response,
    snackbarType: "error",
  })

  dispatch({
    type: PAGES_SERVICE_FAIL,
    payload: response,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}
